import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { fileUrl } from "@/lib/api";

function resolveImage(images) {
  if (!images || images.length === 0) {
    return "https://static.prod-images.emergentagent.com/jobs/d3a3c830-7d3a-49ef-ad18-3f342dc4beda/images/61fe03154047828097ebbc7961c5f590c8897894b9ea6fa9e207bb0d1fee5801.png";
  }
  const first = images[0];
  if (typeof first === "string" && first.startsWith("http")) return first;
  return fileUrl(first);
}

function isFeatured(p) {
  return p.featured_until && new Date(p.featured_until).getTime() > Date.now();
}

export default function ProductCard({ product }) {
  const featured = isFeatured(product);
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className={`card-surface block group ${featured ? "border-[#CCFF00]/40" : ""}`}
    >
      <div className="aspect-[4/5] w-full overflow-hidden bg-[#0A0A0A] relative">
        <img
          src={resolveImage(product.images)}
          alt={product.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 badge-neon">{product.category}</div>
        {featured && (
          <div data-testid={`featured-badge-${product.id}`} className="absolute top-3 right-3 bg-[#CCFF00] text-black text-[10px] uppercase tracking-widest font-black px-2 py-1" style={{boxShadow: "0 0 18px rgba(204,255,0,0.6)"}}>★ Featured</div>
        )}
      </div>
      <div className="p-5 flex flex-col gap-2">
        <h3 className="text-base font-bold text-white truncate" title={product.title}>{product.title}</h3>
        <p className="text-xs text-zinc-500 uppercase tracking-widest">by {product.seller_name}</p>
        {product.review_count > 0 && (
          <div className="flex items-center gap-1 text-xs text-zinc-400" data-testid={`product-card-rating-${product.id}`}>
            <Star className="w-3 h-3 fill-[#FFB800] text-[#FFB800]" strokeWidth={1.5} />
            <span>{Number(product.avg_rating).toFixed(1)}</span>
            <span className="text-zinc-600">({product.review_count})</span>
          </div>
        )}
        <div className="flex items-baseline justify-between mt-2">
          <span className="font-display text-xl font-bold text-[#FF007F] text-glow-pink">${Number(product.price).toFixed(2)}</span>
          <span className="text-[10px] text-zinc-500 uppercase tracking-widest">View</span>
        </div>
      </div>
    </Link>
  );
}
